import { Outlet, useLocation } from "react-router";
import { PageShell } from "../../components/layout/PageShell";

export const PAG_BASE_PATH = "/privilege-governance-assurance";

interface PagView {
  id: string;
  label: string;
  segment: string;
  subtitle: string;
}

/* The views are sidebar sub-pages, not tabs: the nav owns the switching,
   this shell only titles whichever one is routed to. */
const VIEWS: PagView[] = [
  {
    id: "privilege-access-insights",
    label: "Privilege Access Insights",
    segment: "privilege-access-insights",
    subtitle:
      "Trace privileged access from application to account, identity, and granted policy",
  },
  {
    id: "privilege-governance-assurance",
    label: "Privilege Access Insights",
    segment: "privilege-governance-assurance",
    subtitle:
      "Trace privileged access from application to account, identity, and granted policy",
  },
  {
    id: "user-access-review",
    label: "Privilege Access Insights",
    segment: "user-access-review",
    subtitle:
      "Trace privileged access from application to account, identity, and granted policy",
  },
  {
    id: "privilege-insights",
    label: "Privilege Access Insights",
    segment: "privilege-insights",
    subtitle: "Insights into privileged access and policy utilization.",
  },
  {
    id: "access-review",
    label: "Access Review",
    segment: "access-review",
    subtitle: "Review, govern, and revoke privileged account access across source systems.",
  },
  {
    id: "account-configuration",
    label: "Configuration",
    segment: "account-configuration",
    subtitle:
      "Configure directory groups as privileged and classify their risk levels across systems.",
  },
  {
    id: "pga-configuration",
    label: "Configuration",
    segment: "pga-configuration",
    subtitle:
      "Configure directory groups as privileged and classify their risk levels across systems.",
  },
  {
    id: "risk-configuration",
    label: "Configuration",
    segment: "risk-configuration",
    subtitle:
      "Configure directory groups as privileged and classify their risk levels across systems.",
  },
  {
    id: "schedulers",
    label: "Schedulers",
    segment: "schedulers",
    subtitle: "Schedule the recurring jobs that keep privileged access data current.",
  },
  {
    id: "iam-policy-categorization",
    label: "IAM Policy Categorization",
    segment: "iam-policy-categorization",
    subtitle: "Categorize and triage IAM policies across risk classification bands.",
  },
];

const pathFor = (view: PagView) =>
  view.segment ? `${PAG_BASE_PATH}/${view.segment}` : PAG_BASE_PATH;

export const PrivilegeAccessGovernancePage = () => {
  const { pathname } = useLocation();

  // Longest segment first
  const active =
    [...VIEWS]
      .sort((a, b) => b.segment.length - a.segment.length)
      .find((view) => pathname === pathFor(view) || pathname.startsWith(`${pathFor(view)}/`)) ??
    VIEWS[0];

  return (
    <PageShell className="flex min-h-0 flex-1 flex-col gap-4">
      <div>
        <h1 className="text-xl font-semibold text-foreground">{active.label}</h1>
        <p className="text-xs text-muted-foreground">{active.subtitle}</p>
      </div>

      <Outlet />
    </PageShell>
  );
};
